import React from 'react';
import { useTheme } from '@mui/material/styles';
import {
  Link,
  Container,
  Box,
  Button,
  Typography,
  useMediaQuery,
  Grid,
} from '@mui/material';
import { Link as RouterLink } from 'react-router';

export default function Oops() {
  const theme = useTheme();
  const is_md = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });
  const support_email = `support@${import.meta.env.VITE_DOMAIN_SUFFIX}`;

  return (
    <Box
      sx={{
        position: 'relative',
        minHeight: `calc(100vh - ${theme.mixins.toolbar.minHeight}px)`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Container>
        <Grid container spacing={2} sx={{ alignItems: 'center' }}>
          <Grid
            size={{ xs: 12, md: 6 }}
            sx={{ display: 'flex', justifyContent: 'center' }}
          >
            <Box sx={{ width: 1, maxWidth: 500 }}>
              <Box
                component='img'
                src='/img/not-found.svg'
                alt=''
                sx={{
                  width: 1,
                  height: 'auto',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.8)' : 'none',
                }}
              />
            </Box>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <Typography
              variant='h6'
              component='p'
              color='text.secondary'
              align={is_md ? 'left' : 'center'}
            >
              Oops! Looks like you followed a bad link.
              <br />
              If you think this is a problem with us, please{' '}
              <Link
                href={`mailto:${support_email}?subject=Broken%20Link`}
                underline='none'
              >
                tell us
              </Link>
            </Typography>
            <Box
              sx={{
                mt: 4,
                display: 'flex',
                justifyContent: { xs: 'center', md: 'flex-start' },
              }}
            >
              <Button
                component={RouterLink}
                variant='contained'
                color='primary'
                size='large'
                to='/dashboard'
              >
                Back home
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
